<div class="w-full" [formGroup]="formGroup()" #inputContainer>
  <div
    [class]="containerClasses()"
    [tabIndex]="-1"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
    (click)="onClickElement()"
  >
    @if (leftIcon() !== '') {
      <svg-icon [src]="leftIcon()" [svgClass]="leftIconClasses()"></svg-icon>
    }
    <input
      [tabIndex]="tabIndexInput()"
      [class]="inputClasses()"
      [formControlName]="controlName()"
      [placeholder]="placeholder()"
      [readonly]="isReadonly()"
      (focus)="onFocus()"
      (blur)="onBlur()"
      [type]="isDropdown() ? 'text' : 'number'"
    />
    @if (amountModifier() !== '') {
      <div [class]="amountModifierClasses()">{{ amountModifier() }}</div>
    }
    @if (rightIconCalculated() !== '') {
      <svg-icon [src]="rightIconCalculated()" [svgClass]="rightIconClasses()"></svg-icon>
    }
  </div>
  @if (message() !== '') {
    <div [class]="messageClasses()">{{ message() }}</div>
  }
</div>
